import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_V2 } from '@paymash/sdk/api/api.conf';
import { Company } from '../../models/backend/company';

@Injectable()
export class CompanyApiService {
  constructor(private http: HttpClient, @Inject(API_V2) private api: string) {}

  private get basePath() {
    return `${this.api}/public`;
  }

  getCompanyById(companyUuid: string): Observable<Company> {
    const params = new HttpParams().set('companyId', companyUuid);
    return this.http.get<Company>(`${this.basePath}/companies`, { params });
  }

  getCompanyByDomain(domain: string): Observable<Company> {
    const params = new HttpParams().set('domain', domain);
    return this.http.get<Company>(`${this.basePath}/companies`, { params });
  }
}
